var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "permission-config-panel" },
    [
      _vm.showDescription
        ? _c("p", { staticClass: "panel-desc" }, [
            _vm._v(
              " 协作者控制问卷可见范围；修改权限控制问卷可编辑范围。选择「另行配置」后，可单独指定可修改人。 "
            ),
          ])
        : _vm._e(),
      _c(
        "el-form",
        {
          staticClass: "permission-form",
          attrs: { "label-width": _vm.labelWidth },
        },
        [
          _c("el-form-item", { attrs: { label: "其他协作者" } }, [
            _c(
              "div",
              { staticClass: "picker-row" },
              [
                _c("span", { staticClass: "selected-count" }, [
                  _vm._v(
                    "已选" + _vm._s(_vm.internalValue.assistants.length) + "人"
                  ),
                ]),
                _c(
                  "el-button",
                  {
                    staticClass: "pick-btn",
                    attrs: { type: "text" },
                    on: {
                      click: function ($event) {
                        return _vm.openPicker("assistant")
                      },
                    },
                  },
                  [_vm._v("选择")]
                ),
              ],
              1
            ),
          ]),
          _c(
            "el-form-item",
            { staticClass: "edit-permission-item" },
            [
              _c(
                "span",
                {
                  staticClass: "section-label",
                  attrs: { slot: "label" },
                  slot: "label",
                },
                [
                  _vm._v(" 修改权限 "),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: { effect: "dark", placement: "top-start" },
                    },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        [
                          _vm._v(
                            "如另行配置修改权限，可修改人需拥有该问卷的可见权限才允许修改问卷"
                          ),
                        ]
                      ),
                      _c("i", { staticClass: "el-icon-question section-help" }),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-radio-group",
                {
                  on: { change: _vm.handleEditModeChange },
                  model: {
                    value: _vm.internalValue.editPermissionMode,
                    callback: function ($$v) {
                      _vm.$set(_vm.internalValue, "editPermissionMode", $$v)
                    },
                    expression: "internalValue.editPermissionMode",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: "VIEW_BASED" } }, [
                    _vm._v("与查看权限一致"),
                  ]),
                  _c("el-radio", { attrs: { label: "CUSTOM" } }, [
                    _vm._v("另行配置"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm.internalValue.editPermissionMode === "CUSTOM"
            ? _c("el-form-item", { attrs: { label: "可修改人" } }, [
                _c(
                  "div",
                  { staticClass: "picker-row" },
                  [
                    _c("span", { staticClass: "selected-count" }, [
                      _vm._v(
                        "已选" + _vm._s(_vm.internalValue.editors.length) + "人"
                      ),
                    ]),
                    _c(
                      "el-button",
                      {
                        staticClass: "pick-btn",
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.openPicker("editor")
                          },
                        },
                      },
                      [_vm._v("选择")]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c("user-picker-dialog", {
        attrs: {
          visible: _vm.pickerVisible,
          title: _vm.pickerDialogTitle,
          value: _vm.pickerDraftValue,
        },
        on: {
          "update:visible": function ($event) {
            _vm.pickerVisible = $event
          },
          confirm: _vm.handlePickerConfirm,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }